import styled from "styled-components";

const UnstyledButton = styled.button`
  border: none;
  cursor: pointer;
  background: none;
  color: inherit;
  margin: 0;
  padding: 0;
  overflow: visible;
  font-size: inherit;

  svg {
    vertical-align: middle;
  }
`;

export default UnstyledButton;



// WEBPACK FOOTER //
// ./src/components/UnstyledButton.js